import SortableList, { SortableItem } from "react-easy-sort";

import React from "react";
const EasySort = React.forwardRef(() => {
  const nameArray = ["akash", "sky", "itzakash"];

  const onSortEnd = ({ old_index, new_index }) => {
    console.log(old_index, new_index);
  };
  return (
    <ul className="preview_slides">
      <SortableList
        onSortEnd={onSortEnd}
        className="list"
        draggedItemClassName="dragged"
      >
        {nameArray &&
          nameArray.length > 0 &&
          nameArray.map((item) => (
            <SortableItem key={item}>
              <div>
                <li>{item}</li>
              </div>
            </SortableItem>
          ))}
      </SortableList>
    </ul>
  );
});

export default EasySort;
